export default function getResource(label, vars = []) {
    const resources = { makeoverAt: 'Séance maquillage chez' };

    return resources[label];
}
